import React from 'react';

function SwapInterface() {
  return (
    <div className="swap-interface">
      <h1>Swap Interface</h1>
      <p>Coming soon...</p>
    </div>
  );
}

export default SwapInterface; 